import { ERouteName } from './../../../config/index';
/**
 * 视图展示类型
 */
export enum ViewType {
  /**
   * 券列表展示模式
   */
  couponList = 'couponList',
  /**
   * 券列表展示模式
   */
  merchantList = 'merchantList'
}

/**
 * 当前视图展示模式：默认券列表
 */
let currViewType = ViewType.couponList;

/**
 * 获取当前视图展示模式
 * @returns
 */
export function getViewType() {
  return currViewType;
}

/**
 *  初始化路由类型
 * @param routerName 路由名称
 */
export function initData(routerName: string) {
  if (routerName === ERouteName.weCouponsSpList) {
    currViewType = ViewType.merchantList;
  }
}

/**
 * 切换视图展示模式
 * @returns
 */
export function switchViewType() {
  let list = [ViewType.couponList, ViewType.merchantList];
  if (currViewType === ViewType.couponList) {
    list = list.reverse();
  }

  [currViewType] = list;
  return currViewType;
}


/** 本地缓存key */
const SwitchBtnClickTag = 'WECOUPONS_SWITCHBTN_TAG';

/**
 * 设置点击缓存为已点击
 */
export function setSwitchBtnClickTag() {
    // 设置标识
    window.localStorage.setItem(SwitchBtnClickTag, '1');
}

/**
 * 是否展示商户的tips
 */
export function isShowMrchTipsInCache() {
  const cache = window.localStorage.getItem(SwitchBtnClickTag);
  const isHadShow = !!cache && +cache === 1;
  return !isHadShow;
}